module.exports = __webpack_public_path__ + "img/RietzProfile.170197db.jpg";